//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
    login,
    getCartCount
} from '../../api';
export default {
    data() {
        return {
            look: false,
            phone: "",
            pwd: ""
        }
    },
    watch: {
        look(val) {
            this.$refs.pswd.type = val ? 'text' : 'password';
        }
    },
    methods: {
        back() {
            this.$store.commit('updateLogin', false)
        },
        loginBtn(phone, password) {
            this.$store.commit('showIsLoading');
            login(`account=${phone}&password=${password}`).then(res => {
                console.log(res);
                if (res.data.error_code) {
                    this.$store.commit('updateToast', {
                        show: true,
                        text: res.data.msg
                    });
                } else {
                    localStorage.setItem('userInfo', JSON.stringify(res.data));
                    this.phone = this.pwd = "";
                    this.$store.commit('updateLoginDate', res.data);
                    this.back();
                    this.$store.commit('showIsTab');
                    this.$router.push({
                        name: 'home'
                    });
                    getCartCount();
                };
            })
        }
    }

}



// WEBPACK FOOTER //
// ./src/components/Login/Login.vue